import { render, staticRenderFns } from "./permitting-groups.vue?vue&type=template&id=4ed81198"
import script from "./permitting-groups.vue?vue&type=script&lang=js"
export * from "./permitting-groups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports